import React, { useEffect } from "react";
import { useDrag } from "react-dnd";
import MetricCard from "../score/MetricCard";
import { useSelector } from "react-redux";
import { RootStatePlatform } from "../../store/platform-slice";
import useTheme from "../../../../common/hooks/useTheme";
import BiomarkerCard from "../score/BiomarkerCard";
import { metricDataType } from "../../../../providers/dataPlatformReportTypes";
import { getEmptyImage } from "react-dnd-html5-backend";

export interface DraggedCard {
  index: number;
  id: string;
  fromSelected: boolean;
}

interface CardComponentProps {
  card: metricDataType;
  index: number;
  fromSelected: boolean;
  type: string;
}

const CardComponent: React.FC<CardComponentProps> = ({
  card,
  index,
  fromSelected,
  type,
}) => {
  const theme = useTheme();
  const reportData = useSelector(
    (state: RootStatePlatform) => state.platform.dataPlatformServer.score
  );
  const [{ isDragging }, dragRef, previewRef] = useDrag({
    type: "CARD",
    item: {
      id: card ? card.id : Math.random().toString(),
      fromSelected,
      index,
      card,
      type,
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  useEffect(() => {
    previewRef(getEmptyImage(), { captureDraggingState: true });
  }, []);

  if (!card) {
    return (
      <div
        style={{
          borderRadius: "8px",
          border: `1px dashed ${theme.colors_ds.NEUTRAL_BORDER_WEAK}`,
          padding: "16px",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          opacity: 0.8,
          marginBottom: "16px",
        }}
      >
        <div>Drag a card here</div>
      </div>
    );
  }

  return (
    <div
      ref={dragRef}
      style={{
        opacity: isDragging ? 0.3 : 1,
        cursor: "move",
        borderRadius: "8px",
        transform: "translate3d(0, 0, 0)",
        backfaceVisibility: "hidden",
        WebkitBackfaceVisibility: "hidden",
        WebkitTransform: "translate3d(0, 0, 0)", // Helps with Safari
      }}
    >
      {type === "metric" && (
        <MetricCard
          item={card}
          key={index}
          categories={reportData.scoreCategories}
          withShadow={false}
          isClickable={false}
        />
      )}
      {type === "biomarker" && (
        <BiomarkerCard
          item={card}
          key={index}
          index={index}
          isClickable={false}
          type={"blood"}
        />
      )}
    </div>
  );
};

export default CardComponent;
